(function () {
  'use strict';

  var LEAFLET_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var LEAFLET_INTEGRITY = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
  var LEAFLET_CSS_URL = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_CSS_INTEGRITY = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
  var TILE_URL = 'https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}';
  var TILE_ATTRIBUTION = 'Tiles &copy; Esri &mdash; Esri, DeLorme, NAVTEQ';
  var DEFAULT_EXPERIENCE_LINK = 'https://essenceandtrove.com/find-us';
  var leafletPromise;

  var SUPPORT_POINTS = [
  {
    "type": "dc",
    "name": "Distribution Center",
    "area": "Baton Rouge, LA",
    "address": "Distribution support hub - Baton Rouge, LA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 30.4515,
    "lng": -91.1871
  },
  {
    "type": "dc",
    "name": "Distribution Center",
    "area": "Tampa, FL",
    "address": "Distribution support hub - Tampa, FL",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 27.9506,
    "lng": -82.4572
  },
  {
    "type": "dc",
    "name": "Distribution Center",
    "area": "Los Angeles, CA",
    "address": "Distribution support hub - Los Angeles, CA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 34.0522,
    "lng": -118.2437
  },
  {
    "type": "dc",
    "name": "Distribution Center",
    "area": "Waco, TX",
    "address": "Distribution support hub - Waco, TX",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 31.5493,
    "lng": -97.1467
  },
  {
    "type": "event",
    "name": "KC Home & Remodel",
    "area": "Kansas City, MO",
    "address": "Road-show event in Kansas City, MO",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 39.0997,
    "lng": -94.5786
  },
  {
    "type": "event",
    "name": "Orange County Home & Garden Show",
    "area": "Orange County, CA",
    "address": "Road-show event in Orange County, CA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 33.7175,
    "lng": -117.8311
  },
  {
    "type": "event",
    "name": "Maricopa County Home & Garden Show",
    "area": "Phoenix, AZ",
    "address": "Road-show event in Phoenix, AZ",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 33.4484,
    "lng": -112.074
  },
  {
    "type": "event",
    "name": "Hawaii Market Expo",
    "area": "Honolulu, HI",
    "address": "Road-show event in Honolulu, HI",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 21.3069,
    "lng": -157.8583,
    "isInset": true
  },
  {
    "type": "event",
    "name": "Twin Cities Home Remodeling Show",
    "area": "Minneapolis, MN",
    "address": "Road-show event in Minneapolis, MN",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 44.9778,
    "lng": -93.265
  },
  {
    "type": "event",
    "name": "San Antonio Home & Garden Show",
    "area": "San Antonio, TX",
    "address": "Road-show event in San Antonio, TX",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 29.4241,
    "lng": -98.4936
  },
  {
    "type": "event",
    "name": "Greater Philadelphia Home Show",
    "area": "Philadelphia, PA",
    "address": "Road-show event in Philadelphia, PA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 39.9526,
    "lng": -75.1652
  },
  {
    "type": "event",
    "name": "Indianapolis Home Show",
    "area": "Indianapolis, IN",
    "address": "Road-show event in Indianapolis, IN",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 39.7684,
    "lng": -86.1581
  },
  {
    "type": "event",
    "name": "Seattle Home Show",
    "area": "Seattle, WA",
    "address": "Road-show event in Seattle, WA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 47.6062,
    "lng": -122.3321
  },
  {
    "type": "event",
    "name": "Denver Home Show",
    "area": "Denver, CO",
    "address": "Road-show event in Denver, CO",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 39.7392,
    "lng": -104.9903
  },
  {
    "type": "event",
    "name": "Dallas Home & Garden Show",
    "area": "Dallas, TX",
    "address": "Road-show event in Dallas, TX",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 32.7767,
    "lng": -96.797
  },
  {
    "type": "event",
    "name": "Columbus Home & Garden Show",
    "area": "Columbus, OH",
    "address": "Road-show event in Columbus, OH",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 39.9612,
    "lng": -82.9988
  },
  {
    "type": "event",
    "name": "Charlotte Home Show",
    "area": "Charlotte, NC",
    "address": "Road-show event in Charlotte, NC",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 35.2271,
    "lng": -80.8431
  },
  {
    "type": "event",
    "name": "Nashville Home & Remodeling Expo",
    "area": "Nashville, TN",
    "address": "Road-show event in Nashville, TN",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 36.1627,
    "lng": -86.7816
  },
  {
    "type": "event",
    "name": "Atlanta Home Show",
    "area": "Atlanta, GA",
    "address": "Road-show event in Atlanta, GA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 33.749,
    "lng": -84.388
  },
  {
    "type": "event",
    "name": "Houston Home & Garden Show",
    "area": "Houston, TX",
    "address": "Road-show event in Houston, TX",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 29.7604,
    "lng": -95.3698
  },
  {
    "type": "event",
    "name": "Oklahoma City Home + Garden Show",
    "area": "Oklahoma City, OK",
    "address": "Road-show event in Oklahoma City, OK",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 35.4676,
    "lng": -97.5164
  },
  {
    "type": "event",
    "name": "Portland Home & Garden Show",
    "area": "Portland, OR",
    "address": "Road-show event in Portland, OR",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 45.5051,
    "lng": -122.675
  },
  {
    "type": "event",
    "name": "Tampa Bay Home Show",
    "area": "Tampa, FL",
    "address": "Road-show event in Tampa, FL",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 27.9506,
    "lng": -82.4572
  },
  {
    "type": "event",
    "name": "Las Vegas Home Show",
    "area": "Las Vegas, NV",
    "address": "Road-show event in Las Vegas, NV",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 36.1699,
    "lng": -115.1398
  },
  {
    "type": "event",
    "name": "Salt Lake Home Show",
    "area": "Salt Lake City, UT",
    "address": "Road-show event in Salt Lake City, UT",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 40.7608,
    "lng": -111.891
  },
  {
    "type": "event",
    "name": "New Orleans Home Show",
    "area": "New Orleans, LA",
    "address": "Road-show event in New Orleans, LA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 29.9511,
    "lng": -90.0715
  },
  {
    "type": "event",
    "name": "Miami Home Design & Remodeling Show",
    "area": "Miami, FL",
    "address": "Road-show event in Miami, FL",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 25.7617,
    "lng": -80.1918
  },
  {
    "type": "event",
    "name": "Chicago Home & Garden Show",
    "area": "Chicago, IL",
    "address": "Road-show event in Chicago, IL",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 41.8781,
    "lng": -87.6298
  },
  {
    "type": "event",
    "name": "Detroit Home Improvement Show",
    "area": "Detroit, MI",
    "address": "Road-show event in Detroit, MI",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 42.3314,
    "lng": -83.0458
  },
  {
    "type": "event",
    "name": "Austin Home & Garden Show",
    "area": "Austin, TX",
    "address": "Road-show event in Austin, TX",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 30.2672,
    "lng": -97.7431
  },
  {
    "type": "event",
    "name": "St. Louis Home & Garden Show",
    "area": "St. Louis, MO",
    "address": "Road-show event in St. Louis, MO",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 38.627,
    "lng": -90.1994
  },
  {
    "type": "event",
    "name": "Pittsburgh Home & Garden Show",
    "area": "Pittsburgh, PA",
    "address": "Road-show event in Pittsburgh, PA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 40.4406,
    "lng": -79.9959
  },
  {
    "type": "event",
    "name": "San Diego Home Show",
    "area": "San Diego, CA",
    "address": "Road-show event in San Diego, CA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 32.7157,
    "lng": -117.1611
  },
  {
    "type": "event",
    "name": "Waxahachie Home Show",
    "area": "Waxahachie, TX",
    "address": "Road-show event in Waxahachie, TX",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 32.3868,
    "lng": -96.8489
  },
  {
    "type": "event",
    "name": "Cattlemens Congress",
    "area": "Oklahoma City, OK",
    "address": "Road-show event in Oklahoma City, OK",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 35.4676,
    "lng": -97.5164
  },
  {
    "type": "event",
    "name": "Boston Home Show",
    "area": "Boston, MA",
    "address": "Road-show event in Boston, MA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 42.3601,
    "lng": -71.0589
  },
  {
    "type": "event",
    "name": "Raleigh Home Show",
    "area": "Raleigh, NC",
    "address": "Road-show event in Raleigh, NC",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 35.7796,
    "lng": -78.6382
  },
  {
    "type": "event",
    "name": "Richmond Home Show",
    "area": "Richmond, VA",
    "address": "Road-show event in Richmond, VA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 37.5407,
    "lng": -77.436
  },
  {
    "type": "event",
    "name": "Sacramento Home & Garden Show",
    "area": "Sacramento, CA",
    "address": "Road-show event in Sacramento, CA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 38.5816,
    "lng": -121.4944
  },
  {
    "type": "event",
    "name": "Albuquerque Home & Garden Show",
    "area": "Albuquerque, NM",
    "address": "Road-show event in Albuquerque, NM",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 35.0844,
    "lng": -106.6504
  },
  {
    "type": "event",
    "name": "Spokane Home & Garden Show",
    "area": "Spokane, WA",
    "address": "Road-show event in Spokane, WA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 47.6587,
    "lng": -117.426
  },
  {
    "type": "event",
    "name": "Louisville Home Show",
    "area": "Louisville, KY",
    "address": "Road-show event in Louisville, KY",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 38.2527,
    "lng": -85.7585
  },
  {
    "type": "event",
    "name": "Memphis Home Show",
    "area": "Memphis, TN",
    "address": "Road-show event in Memphis, TN",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 35.1495,
    "lng": -90.049
  },
  {
    "type": "event",
    "name": "Tulsa Home Show",
    "area": "Tulsa, OK",
    "address": "Road-show event in Tulsa, OK",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 36.154,
    "lng": -95.9928
  },
  {
    "type": "event",
    "name": "Omaha Home Show",
    "area": "Omaha, NE",
    "address": "Road-show event in Omaha, NE",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 41.2565,
    "lng": -95.9345
  },
  {
    "type": "event",
    "name": "Des Moines Home Show",
    "area": "Des Moines, IA",
    "address": "Road-show event in Des Moines, IA",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 41.5868,
    "lng": -93.625
  },
  {
    "type": "event",
    "name": "Milwaukee Home & Garden Show",
    "area": "Milwaukee, WI",
    "address": "Road-show event in Milwaukee, WI",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 43.0389,
    "lng": -87.9065
  },
  {
    "type": "event",
    "name": "Cleveland Home & Remodeling Show",
    "area": "Cleveland, OH",
    "address": "Road-show event in Cleveland, OH",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 41.4993,
    "lng": -81.6944
  },
  {
    "type": "event",
    "name": "Cincinnati Home Show",
    "area": "Cincinnati, OH",
    "address": "Road-show event in Cincinnati, OH",
    "directions": "https://essenceandtrove.com/find-us",
    "lat": 39.1031,
    "lng": -84.512
  }
];

  function loadLeaflet() {
    var stylesheet = document.querySelector(
      'link[data-sleep-city-leaflet-css], link[href*="leaflet@1.9.4/dist/leaflet.css"]'
    );

    if (!stylesheet) {
      stylesheet = document.createElement('link');
      stylesheet.rel = 'stylesheet';
      stylesheet.href = LEAFLET_CSS_URL;
      stylesheet.integrity = LEAFLET_CSS_INTEGRITY;
      stylesheet.crossOrigin = 'anonymous';
      stylesheet.dataset.sleepCityLeafletCss = 'true';
      document.head.appendChild(stylesheet);
    }

    if (window.L) return Promise.resolve(window.L);
    if (leafletPromise) return leafletPromise;

    leafletPromise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[data-sleep-city-leaflet], script[src*="leaflet@1.9.4/dist/leaflet.js"]');

      function handleLoad() {
        if (window.L) resolve(window.L);
        else reject(new Error('Leaflet loaded without exposing window.L.'));
      }

      function handleError() {
        reject(new Error('Leaflet could not be loaded.'));
      }

      if (!script) {
        script = document.createElement('script');
        script.src = LEAFLET_URL;
        script.integrity = LEAFLET_INTEGRITY;
        script.crossOrigin = 'anonymous';
        script.dataset.sleepCityLeaflet = 'true';
        document.head.appendChild(script);
      }

      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });

      if (window.L) handleLoad();
    });

    return leafletPromise;
  }

  function parseNumber(value) {
    var number = Number.parseFloat(value);
    return Number.isFinite(number) ? number : null;
  }

  function directionsUrl(address) {
    return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(address || '');
  }

  function typeLabel(location) {
    if (location.type === 'event') return 'Road-show event';
    if (location.type === 'dc') return 'Distribution center';
    return location.area || 'SleepCity showroom';
  }

  function appendAction(container, label, href, external) {
    if (!label || !href) return;

    var link = document.createElement('a');
    link.href = href;
    link.textContent = label;

    if (external) {
      link.target = '_blank';
      link.rel = 'noopener';
    }

    container.appendChild(link);
  }

  function popupCard(location, experienceLink) {
    var card = document.createElement('div');
    card.className = 'sleep-city-custom-store-locator__popup-card';

    var type = document.createElement('span');
    type.className = 'sleep-city-custom-store-locator__popup-type';
    type.textContent = typeLabel(location);
    card.appendChild(type);

    var name = document.createElement('strong');
    name.textContent = location.name;
    card.appendChild(name);

    var address = document.createElement('p');
    address.textContent = location.address;
    card.appendChild(address);

    if (location.hours) {
      var hours = document.createElement('p');
      hours.textContent = location.hours;
      card.appendChild(hours);
    }

    var actions = document.createElement('div');
    actions.className = 'sleep-city-custom-store-locator__popup-actions';

    if (location.type === 'store') {
      appendAction(actions, 'Directions', directionsUrl(location.address), true);
      appendAction(actions, location.phoneLabel ? 'Call ' + location.phoneLabel : 'Call store', location.phone ? 'tel:' + location.phone : '');
    } else {
      appendAction(actions, 'View Experience Us', experienceLink, true);
    }

    card.appendChild(actions);
    return card;
  }

  class SleepCityStoreLocator extends HTMLElement {
    constructor() {
      super();
      this.map = null;
      this.hawaiiMap = null;
      this.initialized = false;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.initialize();
    }

    disconnectedCallback() {
      if (this.map) this.map.remove();
      if (this.hawaiiMap) this.hawaiiMap.remove();
      this.map = null;
      this.hawaiiMap = null;
      this.initialized = false;
    }

    getSetting(name, fallback) {
      var value = this.dataset[name];
      return value === undefined || value === '' ? fallback : value;
    }

    getBoolean(name) {
      return this.dataset[name] === 'true';
    }

    readStores() {
      var dataElement = this.querySelector('[data-store-locator-stores]');
      if (!dataElement) return [];

      try {
        var records = JSON.parse(dataElement.textContent || '[]');

        return records.map(function (record) {
          return Object.assign({}, record, {
            lat: parseNumber(record.lat),
            lng: parseNumber(record.lng)
          });
        }).filter(function (record) {
          return record.name && record.lat !== null && record.lng !== null;
        });
      } catch (error) {
        console.error('SleepCity Store Locator store data could not be parsed.', error);
        return [];
      }
    }

    getLocations() {
      var locations = this.readStores();
      var showEvents = this.getBoolean('showEvents');
      var showDistributionCenters = this.getBoolean('showDistributionCenters');

      SUPPORT_POINTS.forEach(function (location) {
        if (location.type === 'event' && showEvents) locations.push(location);
        if (location.type === 'dc' && showDistributionCenters) locations.push(location);
      });

      return locations;
    }

    markerIcon(L, location, inset) {
      var markerSize = inset ? 24 : 30;
      var markerClass = 'sleep-city-custom-store-locator__marker sleep-city-custom-store-locator__marker--' + location.type;
      var markerContent = '';

      if (inset) {
        markerClass += ' sleep-city-custom-store-locator__marker--inset';
        markerContent = [
          '<svg class="sleep-city-custom-store-locator__inset-star" viewBox="0 0 24 24" aria-hidden="true" focusable="false">',
          '<path d="m12 2.75 2.78 5.63 6.22.91-4.5 4.38 1.06 6.19L12 16.94l-5.56 2.92 1.06-6.19L3 9.29l6.22-.91L12 2.75Z"></path>',
          '</svg>'
        ].join('');
      }

      return L.divIcon({
        className: 'sleep-city-custom-store-locator__marker-wrap',
        html: '<span class="' + markerClass + '" aria-hidden="true">' + markerContent + '</span>',
        iconSize: [markerSize, markerSize],
        iconAnchor: [markerSize / 2, markerSize / 2],
        popupAnchor: [0, -(markerSize / 2)]
      });
    }

    addTileLayer(L, map, attributionControl) {
      return L.tileLayer(TILE_URL, {
        maxZoom: 19,
        maxNativeZoom: 18,
        attribution: attributionControl ? TILE_ATTRIBUTION : ''
      }).addTo(map);
    }

    initializeHawaiiInset(L, locations) {
      var insetElement = this.querySelector('[data-hawaii-map]');
      var hawaiiLocation = locations.find(function (location) {
        return location.isInset;
      });

      if (!insetElement || !hawaiiLocation || !this.getBoolean('showHawaiiInset')) return;

      this.hawaiiMap = L.map(insetElement, {
        scrollWheelZoom: false,
        dragging: false,
        touchZoom: false,
        doubleClickZoom: false,
        boxZoom: false,
        keyboard: false,
        zoomControl: false,
        attributionControl: false
      }).setView([20.9, -157.45], 6);

      this.addTileLayer(L, this.hawaiiMap, false);

      L.marker([hawaiiLocation.lat, hawaiiLocation.lng], {
        icon: this.markerIcon(L, hawaiiLocation, true),
        interactive: false,
        title: hawaiiLocation.name
      }).addTo(this.hawaiiMap);

      var insetMap = this.hawaiiMap;
      window.setTimeout(function () {
        insetMap.invalidateSize();
      }, 250);
    }

    initializeMainMap(L, locations) {
      var mapElement = this.querySelector('[data-store-locator-map]');
      if (!mapElement) return;

      this.map = L.map(mapElement, {
        scrollWheelZoom: false,
        zoomControl: false,
        attributionControl: true
      });

      L.control.zoom({ position: 'bottomright' }).addTo(this.map);
      this.addTileLayer(L, this.map, true);

      var bounds = [];
      var experienceLink = this.getSetting('experienceLink', DEFAULT_EXPERIENCE_LINK);
      var map = this.map;
      var component = this;

      locations.forEach(function (location) {
        var marker = L.marker([location.lat, location.lng], {
          icon: component.markerIcon(L, location, false),
          keyboard: true,
          title: location.name,
          alt: location.name
        }).addTo(map);

        marker.bindPopup(popupCard(location, experienceLink), {
          className: 'sleep-city-custom-store-locator__popup',
          closeButton: true,
          maxWidth: 260
        });

        if (!location.isInset) {
          bounds.push([location.lat, location.lng]);
        }
      });

      if (bounds.length) {
        this.map.fitBounds(bounds, {
          padding: window.innerWidth < 750 ? [28, 28] : [52, 52],
          maxZoom: 5
        });
      } else {
        this.map.setView([37.8, -96], 4);
      }

      window.setTimeout(function () {
        map.invalidateSize();
      }, 350);
    }

    setStatus(message) {
      var status = this.querySelector('[data-store-locator-status]');
      if (status) status.textContent = message;
    }

    initialize() {
      var component = this;

      loadLeaflet().then(function (L) {
        if (!component.isConnected) return;

        var locations = component.getLocations();
        component.initializeMainMap(L, locations);
        component.initializeHawaiiInset(L, locations);
        component.setStatus('Store locator map loaded.');
      }).catch(function (error) {
        console.error('SleepCity Store Locator could not initialize.', error);
        component.setStatus('The map is currently unavailable. Store details are listed below.');
      });
    }
  }

  if (!customElements.get('sleep-city-store-locator')) {
    customElements.define('sleep-city-store-locator', SleepCityStoreLocator);
  }
})();